import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrdersService } from '../../../../services/orders';
@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrl: './result.component.scss'
})
export class ResultComponent {
  contentReady: boolean = true;
  allData!: any;
  stockTotal: number = 0;
  isAr: boolean = localStorage.getItem("language") == "ar";
  constructor(
    private route: ActivatedRoute, private _orderService: OrdersService
  ) { }
  ngOnInit() {
    this.contentReady = true;
    this.route.queryParams.subscribe(params => {
      if (params['ids']) {
        const ids = params['ids'].split(',').map((x: string) => +x); // يحولها لأرقام
        this.getProducts(ids);
      } else {
        console.warn("No IDs found in query params!");
      }
    });
  }
  getProducts(products: any[]) {
    this.contentReady = true;
    this._orderService.getByIds(products).subscribe({
      next: (data: any) => {  // هنا خليه any مش any[]
        this.allData = data;
        this.contentReady = false;
        this.stockTotal = this.allData.length;
      },
      error: (err) => {
        console.error('Error fetching stocks:', err);
      }
    });

  }
}
